export interface IEventsSettingsSchema {
    visitsEventsEnabled: boolean;
    visitsMinRadius: number;
    visitsMinPermanence: number;
    stopEventsEnabled: boolean;
    stopMaxTime: number;
    stopStopoverEnabled?: boolean;
    stopStopoverThresholdMinutes?: number;
    instantMaxSpeedEnabled: boolean;
    instantMaxSpeed: number;
    sustainedMaxSpeedEnabled: boolean;
    sustainedMaxSpeed: number;
    sustainedMaxSpeedThreshold: number;
}
